import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const DoubleChinCause = lazyWithPreload(
  () => import('./DoubleChinCause'),
)
